<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()"  *ngIf="lang">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">

          <label>{{ lang.executionDate }}</label>
          <input type="date" class="form-control" formControlName="date_of_intervention"
            [ngClass]="formErrorClass(createForm.controls.date_of_intervention, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.date_of_intervention, value:createForm.controls.date_of_intervention, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ lang.description }}</label>
          <textarea class="form-control" formControlName="description"
            [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.description, value:createForm.controls.description, submitted:createFormSubmitted }">
          </ng-template>
        </div>
      </div>



      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">

          <label>{{ lang.performer }}</label>
          <input type="text" class="form-control" formControlName="performer"
            [ngClass]="formErrorClass(createForm.controls.performer, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.performer, value:createForm.controls.performer, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">

        <div class="form-group col-sm-12">
          <label>{{ lang.outcome }}</label>
          <div>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="outcome" value="positive"
                [ngClass]="formErrorClass (createForm.controls.outcome, createFormSubmitted)"><i></i> {{ lang.positive }}
            </label>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="outcome" value="negative"
                [ngClass]="formErrorClass (createForm.controls.outcome, createFormSubmitted)"><i></i>
              {{ lang.negative }}
            </label>

            <ng-template [ngTemplateOutlet]="ErrorMsg"
              [ngTemplateOutletContext]="{msg:createFormErrorMsg.outcome, value:createForm.controls.outcome, submitted:createFormSubmitted }">
            </ng-template>

          </div>
        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>{{ lang.note }}</label>
          <textarea class="form-control" formControlName="note"
            [ngClass]="formErrorClass(createForm.controls.note, createFormSubmitted)"></textarea>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.note, value:createForm.controls.note, submitted:createFormSubmitted }">
          </ng-template>
        </div>
      </div>




      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">

          <label>{{ lang.cost }}</label>
          <input type="text" class="form-control" formControlName="cost"
            [ngClass]="formErrorClass(createForm.controls.cost, createFormSubmitted)">

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.cost, value:createForm.controls.cost, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>
      <!-- <div class="form-group col-sm-12">

        <div class="form-group col-sm-12">
          <label>{{ lang.nextDeadline }}</label>
          <div>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="change_deadline" value="change"
                [ngClass]="formErrorClass (createForm.controls.change_deadline, createFormSubmitted)" (change)="checkValue('change')"><i></i> {{ lang.change }}
            </label>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="change_deadline" value="do_no_affect"
                [ngClass]="formErrorClass (createForm.controls.change_deadline, createFormSubmitted)" (change)="checkValue('do_no_affect')"><i></i>
                {{ lang.donotaffect }}
            </label>
          </div>
        </div>
      </div> -->

      <div class="form-group col-sm-12">

        <div class="form-group col-sm-12">
          <label>{{ lang.nextDeadline }}</label>
          <div>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="change_deadline" value="change" 
                [ngClass]="formErrorClass (createForm.controls.change_deadline, createFormSubmitted)" (change)="checkValue('change')"><i></i> {{ lang.change }}
            </label>
            <label class="checkbox-inline checkbox-custom-alt">
              <input type="radio" formControlName="change_deadline" value="do_no_affect"
                [ngClass]="formErrorClass (createForm.controls.change_deadline, createFormSubmitted)" (change)="checkValue('do_no_affect')"><i></i>
              {{ lang.donotaffect }}
            </label>
          </div>
        </div>
      </div>

      <div class="form-group col-sm-12" id="referdate" style="display: none;">
        <div class="form-group col-sm-12">
          <label>{{ lang.referringDate }}</label>
          <input type="date" class="form-control" formControlName="reference_date"
            [ngClass]="formErrorClass(createForm.controls.reference_date, createFormSubmitted)">
          <!-- <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.reference_date, value:createForm.controls.reference_date, submitted:createFormSubmitted }">
          </ng-template> -->

        </div>
      </div>

      <div class="col-sm-12" formArrayName="ex_document_link">
        <div class="form-group col-sm-12">
          <label>{{ lang.attachments }}</label>
          <div class="form-group row" *ngFor="let link of ex_document_link().controls; let i = index;"
            [formGroupName]="i">
            <div class="col-sm-11">
              <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment1($event,i)"
                formControlName="link">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:createFormErrorMsg.ex_document_link, value:ex_document_link().controls[i].controls['link'], submitted:createFormSubmitted }">
              </ng-template>

            </div>
            <div class="col-sm-1">
              <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)"
                *ngIf=" i!=(ex_document_link().controls.length-1) ">
                <i class="fa fa-trash-o"></i>
              </button>
              <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()"
                *ngIf=" i==(ex_document_link().controls.length-1) ">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12" formArrayName="service_attach_uploaded">
        <div class="form-group col-sm-12">

          <div class="form-group row" *ngFor="let image of service_attach_uploaded().controls; let i=index">
            <div class="col-sm-11">
              <input type="hidden" class="form-control" formControlName="{{i}}">
              <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)"
                value="{{image.value.split('/').pop()}}">

              <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/servicing/{{image.value.split('/').pop()}}"
                target="_blank">{{image.value.split('/').pop()}}</a>

            </div>
            <div class="col-sm-1">
              <button class="btn btn-primary pull-right" type="button" (click)="removeAttachmentUploaded(i)">
                <i class="fa fa-trash-o"></i>
              </button>
            </div>
          </div>
        </div>
      </div>




      <!--
<div class="col-sm-12" formArrayName="timetable_link_uploaded">
<div class="form-group row" *ngFor="let image of timetable_link_uploaded().controls; let i=index">
<div class="col-sm-11">
<input type="hidden" class="form-control" formControlName="{{i}}">

<a (click)="imagePreview(image.value)"
>{{image.value.split('/').pop()}}</a>

</div>
<div class="col-sm-1">
<button class="btn btn-primary pull-right" type="button" (click)="removeAttachmentUploaded(i)">
<i class="fa fa-trash-o"></i>
</button>
</div>
</div>
</div>

                                        <div class="col-sm-12" formArrayName="send_email">
<label>Reference Email</label>
<div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
<div class="col-sm-11">
<input type="text" class="form-control" formControlName="{{i}}" [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">

<ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }"></ng-template>

</div>
<div class="col-sm-1">
<button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)" *ngIf=" i!=(send_email().controls.length-1) ">
<i class="fa fa-trash-o"></i>
</button>
<button class="btn btn-primary pull-right" type="button" (click)="addEmail()" *ngIf=" i==(send_email().controls.length-1) ">
<i class="fa fa-plus"></i>
</button>
</div>
</div>
</div> -->

    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">Save</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <!-- <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang.close }}</button> -->

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>